import { useEffect } from "react";
import { useLogger } from "@src/presentation/hooks/logger/useLogger";
import ErrorBoundary from "@src/presentation/components/common/ErrorBoundary";
import { EmptyState, Heading, Icons, Paragraph } from "@ir/ui";
import {
  PageContent,
  PageFooter,
  PageHeader,
} from "@src/presentation/components/Layout/common";

/**
 * Dashboard Page - Presentation layer
 * Single Responsibility: Displays user dashboard
 */
export const Dashboard = () => {
  const { logger } = useLogger({ componentName: "Dashboard" });
  useEffect(() => {
    logger.info("Dashboard page mounted for sentry logging");
  }, []);
  return (
    <ErrorBoundary>
      <PageHeader title="Dashboard" />
      <PageContent>
        <EmptyState
          className="bg-white border-1 border-color-grey-25 px-4 py-5 m-4"
          icon={Icons.BarChart5}
          title={
            <Heading level={6} className="text-grey-700 font-bold mt-3">
              Welcome to the Dashboard
            </Heading>
          }
          description={
            <Paragraph className="text-grey-500 font-regular mb-0">
              This is where you can view all your dashboard related data
            </Paragraph>
          }
        />
      </PageContent>
      <PageFooter />
    </ErrorBoundary>
  );
};
